/** Maps a value into a clamped percentage over `[min, max]`; degenerate domains center at 50%. */
export function rangePosition(value: number, min: number, max: number): number {
  if (min === max) {
    return 50;
  }
  const ratio = ((value - min) / (max - min)) * 100;
  return Math.min(100, Math.max(0, ratio));
}

export function rangePositionPercent(value: number, min: number, max: number): string {
  return `${rangePosition(value, min, max)}%`;
}
